module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3IiBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgNyAxMCI+CiAgICA8cGF0aCBmaWxsPSIjRDkzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0uNSA4LjExbDMuMjMzLTMuMTdMLjU1OCAxLjgzIDEuOTE3LjUgNi41IDQuOTk2IDEuOTE3IDkuNXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.svg
// module id = l4LJ
// module chunks = 1 2 3 4 5